//import Index from '@/pages/Sellpoint/Index'
// import Sellpoint from '@/pages/Sellpoint/Sellpoint'
// export default {
//   path: '/:id',
//   name: 'Sellpoint',
//   component: Sellpoint
// }

// import Product from '@/pages/Sellpoint/Product'

// export default {
//     path: '/:id',
//     component: Sellpoint,
//     children: [
//       {
//         path: '',
//         name: 'Sellpoint',
//         component: Sellpoint
//       },
     
//     ]
// }

import Product from '@/pages/Sellpoint/Product'
import Sellpoint from '@/pages/Sellpoint/Sellpoint'
import SellpointTemplate from '@/pages/Sellpoint/SellpointTemplate'
export default {
    //path: '/:id',
    // path: '/set/sellpoint',
    path: '',
    component: SellpointTemplate,
    children: [
      {
        path: '/set/sellpoint',
        name: 'Business Page',
        component: Sellpoint
      },
      // {
      //   path: ':id1',
      //   name: 'Product',
      //   component: Product,
      // },
      // {
      //   path: ':id1/:ref0',
      //   name: 'RefProduct',
      //   component: Product,
      // },
      // {
      //   path: 'g/:idg',
      //   name: 'Gallery',
      //   component: Sellpoint,
      // }
    ]
}



// WEBPACK FOOTER //
// ./src/router/sellpoint.js